import {
  Component,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
  ViewChild,
  inject,
} from '@angular/core';
import { Store } from '@ngxs/store';
import {
  SepTableComponent,
  SepTableType,
} from '../../../../../shared/components/sep-table/sep-table.component';
import { TranslocoDirective } from '@jsverse/transloco';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BadgeComponent } from '../../../../../shared/components/badge/badge.component';
import { UserCardComponent } from '../../../../../shared/components/user-card/user-card.component';
import { EnrollmentTableBaseComponent } from '../../../base/EnrollmentTableBaseComponent';
import { StudentEligibleForEnrollmentBaseUIModel } from '../../../base/EnrolledStudentBaseUIModel';
import { CommonModule } from '@angular/common';
import { HrisIntegrationBannerComponent } from '../../../../organization/organization/components/hris-integration-banner/hris-integration-banner.component';
import { FeatureFlagsService } from '../../../../../core/services/feature-flag.service';
import { CurrentUserState } from '../../../../../core/store/current-user/current-user.state';

@Component({
  selector: 'app-learning-plan-enrollment-table',
  imports: [
    CommonModule,
    UserCardComponent,
    SepTableComponent,
    TranslocoDirective,
    BadgeComponent,
    MatIconModule,
    MatTooltipModule,
    HrisIntegrationBannerComponent,
  ],
  templateUrl: './learning-plan-enrollment-table.component.html',
})
export class LearningPlanEnrollmentTableComponent extends EnrollmentTableBaseComponent {
  private readonly featureFlagsService = inject(FeatureFlagsService);
  private readonly store = inject(Store);

  @Input({ required: true })
  students!: StudentEligibleForEnrollmentBaseUIModel[];
  @Input() selectedStudents: StudentEligibleForEnrollmentBaseUIModel[];
  @Input() searchTerm = '';
  @Output() primaryButtonClickEvent: EventEmitter<void> =
    new EventEmitter<void>();
  @Output() searchTermChanged: EventEmitter<string> =
    new EventEmitter<string>();
  @ViewChild('personCard', { static: true }) personCard!: TemplateRef<{
    $implicit: string;
  }>;
  @ViewChild('licenseBadge', { static: true }) licenseBadge!: TemplateRef<{
    $implicit: string;
  }>;
  sepTableType = SepTableType;
  private readonly currentUserEmail: string | undefined;

  constructor() {
    super();
    const userDetails = this.store.selectSnapshot(CurrentUserState.userDetails);
    this.currentUserEmail = userDetails.email;
  }

  protected configureColumns(): void {
    this.columns[0].renderComponent = this.personCard;
    this.columns.push({
      headerName: this.getTranslation('licenseStatus'),
      renderComponent: this.licenseBadge,
      key: 'license',
    });
  }

  isStudentSelected(studentId: string): boolean {
    return this.selectedStudents.some((s) => s.id === studentId);
  }

  isCurrentUser(student: StudentEligibleForEnrollmentBaseUIModel): boolean {
    return this.currentUserEmail === student.email;
  }

  isHRISEnabled() {
    return this.featureFlagsService.isFeatureEnabled(
      this.featureFlagsService.hris,
    );
  }

  onSearchTermChanged(searchTerm: string): void {
    this.searchTermChanged.emit(searchTerm);
  }
}
